/* eslint-disable no-undef */
import './europe-map.scss';
import CountUp from 'countup.js';
import SimpleScrollbar from 'simple-scrollbar';
import 'simple-scrollbar/simple-scrollbar.css';

class EuropeMap {
    constructor ($element) {
        this.$em = $element;
        this.$emMap = 'europe-map__map-id';
        this.$emMapHolder = this.$em.querySelector('[data-europe-map="map-holder"]');
        this.emMapStateFilterClass = 'europa-map--filter-open';
        this.allFacilities = facilityObj;
        this.isMobileBp = window.matchMedia('(max-width: 767px)');
        this.isMobile = this.isMobileBp.matches;

        this.$factBar = this.$em.querySelector('[data-fact-bar="root"]');
        this.$$allFactBarCount = this.$factBar.querySelectorAll('[data-fact-bar-count]');
        this.$factBarStateHandler = this.$em.querySelector('[data-fact-bar="state-handler"]');
        this.factBarStateClass = 'fact-bar--is-open';

        this.$facilityList = this.$em.querySelector('[data-facility-list="root"]');
        this.$allFacilityListItems = this.$em.querySelectorAll('[data-id-marker]');
        this.$facilityListClose = this.$em.querySelector('[data-facility-list="close"]');
        this.$facilityListCount = this.$em.querySelector('[data-facility-list="count"]');
        this.$facilityListStateHandler = this.$em.querySelector('[data-europe-map="open-facility-list"]');
        this.facilityListStateClass = 'europe-map--facility-list-open';

        this.$filter = document.querySelector('[data-filter-root]');
        this.$$allFilters = this.$filter.querySelectorAll('[data-filter]');
        this.$filterClose = this.$filter.querySelector('[data-filter-close]');
        this.$filterReset = this.$filter.querySelector('[data-filter-reset]');
        this.$headerFilterReset = this.$em.querySelector('[data-europe-map="reset-filters"]');
        this.$filterSearch = this.$filter.querySelector('[data-filter-search]');
        this.$filterSearchCount = this.$filter.querySelector('[data-filter-search-count]');
        this.$$filterStateHandlers = this.$em.querySelectorAll('[data-europe-map="open-filters"]');
        this.$filterCount = document.querySelector('[data-filter-count]');
        this.$filterContent = this.$filter.querySelector('[data-filter-content]');
        this.openFilterClass = 'filter-flyout--is-open';
        this.activeFilterClass = 'filter-flyout__filter-group-item--active';
        this.$header = document.querySelector('[data-site-header]');
        this.$qiuckFilter = this.$em.querySelectorAll('[data-quick-filter]');
        this.$noResults = this.$em.querySelector('[data-europe-map="no-results"]');
        this.$noResultsCta = this.$em.querySelector('[data-europe-map="no-results-cta"]');
        this.noResultsStateClass = 'europe-map__no-results--shown';

        this.map = '';
        this.markerIconActive = '';
        this.mapIsInit = false;
        this.activeZoom = 4;

        this.allMarkers = [];
        this.matchingMarkers = [];
        this.filter = {
            type: [],
            country: [],
            business: [],
            state: []
        };

        this.activeFilterCount = 0;
    }

    init () {
        window.ym.ready((modules) => {
            if (this.mapIsInit === false) {
                this.initMap();
                this.initClusterer();
                this.initMarkers();
            }

            setTimeout(() => {
                this.setEvents();
                this.factBarCounter();
            }, 750);
        });

        this.isMobileBp.addEventListener('change', (e) => {
            this.isMobile = e.matches;
            this.activeZoom = window.map.getZoom();

            setTimeout(() => {
                window.map.invalidateSize();
            }, 500);

            if (this.isMobile) {
                console.log('Mobile Endgeräte');
                SimpleScrollbar.initEl(this.$filterContent);
            }
        });

        window.resizeHandler.customFunctions.push(() => {
            this.activeZoom = window.map.getZoom();

            setTimeout(() => {
                window.map.invalidateSize();
            }, 500);
        });

        if (this.isMobile) {
            SimpleScrollbar.initEl(this.$filterContent);
        }
    }

    setEvents () {
        document.addEventListener('darkmode', (e) => {
            const style = e.detail.darkmode ? 'darkmode simplified' : 'lightmode simplified';
            const center = window.map.getCenter();
            const zoom = window.map.getZoom();
            window.map.remove();
            const map = ym.map('europe-map__map-id', {
                center: center,
                zoom: zoom,
                minZoom: 2,
                maxZoom: 8,
                zoomControl: false,
                brandControl: false,
                style: style
            });
            window.map = map;
            this.initClusterer();
            this.initMarkers();

            window.map.addLayer(this.clusterer);
        });

        this.$factBarStateHandler.addEventListener('click', () => {
            this.factBarHandler();
        });

        this.$facilityListStateHandler.addEventListener('click', () => {
            this.facilityListHandler(this.isMobile);
            setTimeout(() => {
                window.map.invalidateSize();
            }, 300);
        });

        // close facility list
        this.$facilityListClose.addEventListener('click', () => {
            this.facilityListHandler(this.isMobile);
            setTimeout(() => {
                window.map.invalidateSize();
            }, 300);
        });

        // close filter flyout
        this.$filterClose.addEventListener('click', () => {
            this.activeZoom = window.map.getZoom();
            this.filterHandler();
            this.resetFilter(this.activeZoom);
            this.resetFacts();
        });

        // save/remove each clicked filter in this.filter
        // add/remove active class for clicked filter
        this.$$allFilters.forEach(filter => {
            filter.addEventListener('click', () => {
                this.matchingMarkers = [];

                const matchQuickFilter = this.$em.querySelector('[data-quick-filter="' + filter.dataset.filterValue + '"]');

                if (filter.classList.contains(this.activeFilterClass) || filter.classList.contains('filter-flyout__quick-filter--active') || filter.classList.contains('europe-map__quick-filter--active')) {
                    if (filter.dataset.filter === 'type') {
                        matchQuickFilter.classList.remove('europe-map__quick-filter--active');
                        filter.classList.remove('filter-flyout__quick-filter--active');
                    } else {
                        filter.classList.remove(this.activeFilterClass);
                    }

                    const index = this.filter[filter.dataset.filter].indexOf(filter.dataset.filterValue);
                    if (index > -1) { // only splice array when item is found
                        this.filter[filter.dataset.filter].splice(index, 1); // 2nd parameter means remove one item only
                    }
                    this.activeFilterCount--;
                } else {
                    if (filter.dataset.filter === 'type') {
                        matchQuickFilter.classList.add('europe-map__quick-filter--active');
                        filter.classList.add('filter-flyout__quick-filter--active');
                    } else {
                        filter.classList.add(this.activeFilterClass);
                    }

                    this.filter[filter.dataset.filter].push(filter.dataset.filterValue);
                    this.activeFilterCount++;
                }
                console.log('this.filter:', this.filter);
                console.log('this.activeFilterCount:', this.activeFilterCount);
                this.countAllMatchingFilters();

                this.$filterSearchCount.innerText = `${this.matchingMarkers.length} `;

                if (this.activeFilterCount >= 1) {
                    this.$filterReset.classList.add('filter-flyout__reset--shown');
                    this.$headerFilterReset.classList.add('europe-map__filter-reset--is-shown');
                } else {
                    this.$filterReset.classList.remove('filter-flyout__reset--shown');
                    this.$headerFilterReset.classList.remove('europe-map__filter-reset--is-shown');
                }

                // set disable to button
                this.hideSearchCta();

                console.log('this.matchingMarkers.length', this.matchingMarkers.length);
            });
        });

        // quickfilter handler
        this.$qiuckFilter.forEach(filter => {
            filter.addEventListener('click', () => {
                const matchFilter = this.$filter.querySelector('[data-filter-value="' + filter.dataset.quickFilter + '"]');
                if (matchFilter) {
                    matchFilter.click();
                    if (this.matchingMarkers.length === 0) {
                        this.noResultsHandler();
                    } else {
                        this.startFilter();
                    }
                }
            });
        });

        // open filter flyout
        this.$$filterStateHandlers.forEach(cta => {
            cta.addEventListener('click', () => {
                this.filterHandler();
            });
        });

        // start filter
        this.$filterSearch.addEventListener('click', () => {
            this.startFilter();
            this.filterHandler();
        });

        // reset filters
        this.$filterReset.addEventListener('click', () => {
            this.resetFilter();
            this.resetFacts();
        });

        this.$headerFilterReset.addEventListener('click', () => {
            this.resetFilter();
            this.resetFacts();
        });

        this.$noResultsCta.addEventListener('click', () => {
            this.resetFilter();
            this.noResultsHandler();
        });

        this.$allFacilityListItems.forEach(item => {
            item.addEventListener('click', () => {
                const itemId = item.dataset.idMarker;
                item.classList.remove('facility-list__list-item--active');
                this.allMarkers.forEach(marker => {
                    if (marker.filter.name === itemId) {
                        item.classList.add('facility-list__list-item--active');

                        window.map.setView(marker.getLatLng(), 8);

                        this.clusterer.zoomToShowLayer(marker, (e) => {
                            this.activeZoom = window.map.getZoom();
                            window.map.setView(marker.getLatLng(), this.activeZoom);
                            marker.openPopup();
                        });

                        if (this.$factBar.classList.contains(this.factBarStateClass)) {
                            this.$factBar.classList.remove(this.factBarStateClass);
                        }
                    }
                });
            });
        });

        this.allMarkers.forEach(marker => {
            marker.on('click', (e) => {
                this.$allFacilityListItems.forEach(item => {
                    item.classList.remove('facility-list__list-item--active');
                });
                marker.filter.facilityListItem.classList.add('facility-list__list-item--active');
                this.activeZoom = window.map.getZoom();
                window.map.setView(e.target.getLatLng(), this.activeZoom);

                if (this.isMobile) {
                    this.scrollInView(this.$emMapHolder);
                }
            });
        });
    }

    scrollInView (el) {
        const topOffset = 50;
        const elRect = el.getBoundingClientRect();
        const scrollY = window.scrollY || window.pageYOffset;
        const top = elRect.top + scrollY - topOffset;
        window.scrollTo({ top, behavior: 'smooth' });
    }

    facilityListHandler (isMobile) {
        console.log('isMobile', isMobile);
        console.log('isNOTMobile', !isMobile);
        if (this.$em.classList.contains(this.facilityListStateClass)) {
            this.$em.classList.remove(this.facilityListStateClass);
            if (isMobile) {
                document.body.style.overflow = '';
            }
        } else {
            this.$em.classList.add(this.facilityListStateClass);

            if (isMobile) {
                this.scrollInView(this.$facilityList);
                document.body.style.overflow = 'hidden';
            }
        }
    }

    filterHandler () {
        if (this.$filter.classList.contains(this.openFilterClass)) {
            document.body.style.overflow = '';
            document.querySelector('.site-main').style.zIndex = 1;
            this.$filter.classList.remove(this.openFilterClass);
            this.$em.classList.remove(this.emMapStateFilterClass);
            this.$header.classList.remove('site-header--filter-open');
        } else {
            document.body.style.overflow = 'hidden';
            document.querySelector('.site-main').style.zIndex = 2;
            this.$filter.classList.add(this.openFilterClass);
            this.$em.classList.add(this.emMapStateFilterClass);
            this.$header.classList.add('site-header--filter-open');
        }
    }

    factBarHandler () {
        this.$factBar.classList.toggle(this.factBarStateClass);
        this.factBarCounter(open);
    }

    initMap () {
        const mapStyle = window.darkModeState ? 'darkmode simplified' : 'lightmode simplified';
        const map = ym.map('europe-map__map-id', {
            center: ym.latLng(50.095685, 8.690445),
            minZoom: 2,
            zoom: 4,
            maxZoom: 8,
            brandControl: false,
            style: mapStyle,
            zoomControl: false
        });

        map.addControl(
            new ym.modules.provider.Control.Zoom({
                position: 'bottomleft'
            })
        );
        window.map = map;
    }

    // set cluster
    initClusterer () {
        this.clusterer = ym.markerClusterGroup({
            showCoverageOnHover: false,
            iconCreateFunction: function (cluster) {
                const markers = cluster.getAllChildMarkers();
                const output =
                    '<b>' +
                    Intl.NumberFormat('de-DE', {
                        maximumSignificantDigits: 3
                    }).format(markers.length) +
                    '</b>';
                return ym.divIcon({
                    html: output,
                    className: 'europe-map__cluster-icon',
                    iconSize: ym.point(24, 32)
                });
            }
        });

        window.map.addLayer(this.clusterer);
    }

    // Marker zusammen bauen
    initMarkers () {
        facilityObj.forEach((facility) => {
            const power = facility.type.toLowerCase() === 'wind' ? 'wind' : 'sun';
            const ppa = facility.open_for_ppa === true ? 'PPA' : '';
            console.log(facility);
            const defaultIcon = ym.divIcon({
                className: `europe-map__facility-pin europe-map__facility-pin--${power}`,
                iconSize: [24, 32],
                popupAnchor: [-175, 175]
            });

            const activeIcon = ym.divIcon({
                className: `europe-map__facility-pin europe-map__facility-pin--active europe-map__facility-pin--${power}`,
                iconSize: [38, 50],
                popupAnchor: [-175, 175]
            });

            // Koordinaten des Markers des aktuellen Datensatzes festlegen
            const e = ym.latLng(
                parseFloat(facility.latitude),
                parseFloat(facility.longitude)
            );
            // Marker definieren
            const marker = ym.marker(e);

            marker.filter = {
                facilityListItem: this.$facilityList.querySelector('[data-id-marker="' + facility.name + '"]'),
                name: facility.name,
                country: facility.country,
                business: facility.business_field,
                type: facility.type,
                state: facility.operation_state,
                inOperationSince: facility.in_operation_since,
                openForPpa: facility.open_for_ppa,
                ratedCapacity: facility.rated_capacity,
                plannedPowerProduction: facility.planned_power_production,
                co2saving: facility.co2saving,
                suppliedHouseholds: facility.supplied_households
            };
            // Icon des Markers definieren => SVG-Icon
            marker.setIcon(defaultIcon);
            // Popup des Markers definieren => hier kann auch HTML übergeben werden

            const ratedCapacityNum = new Intl.NumberFormat('de-DE').format(facility.rated_capacity);
            const powerNum = new Intl.NumberFormat('de-DE').format(facility.planned_power_production);
            const co2Num = new Intl.NumberFormat('de-DE').format(facility.co2saving);

            marker.bindPopup(
                `<div class="europe-map__map-info europe-map__map-info--${power}">
                            <div class="europe-map__map-info-header">
                                <p class="europe-map__map-info-tag">${facility.operation_state}</p>
                                <p class="europe-map__map-info-tag">${ppa}</p>
                            </div>
                            <div class="europe-map__map-info-content">
                                <div class="europe-map__map-info-row">
                                    <p class="europe-map__map-info-name">${facility.name}</p>
                                    <p class="europe-map__map-info-country">${facility.country}</p>
                                    <svg class="europe-map__map-info-icon">
                                        <use href="#icon-${power}"/>
                                    </svg>
                                </div>
                                <div class="europe-map__map-info-row">
                                    <div class="europe-map__map-info-detail">${businessTranslation}</div>
                                    <div class="europe-map__map-info-detail">${facility.business_field}</div>
                                </div>
                                <div class="europe-map__map-info-row">
                                    <div class="europe-map__map-info-detail">${ratedCapacityTranslation}</div>
                                    <div class="europe-map__map-info-detail">${ratedCapacityNum} MW</div>
                                </div>
                                <div class="europe-map__map-info-row">
                                    <div class="europe-map__map-info-detail">${powerProductionTranslation}</div>
                                    <div class="europe-map__map-info-detail">${powerNum} kWh/a</div>
                                </div>
                                <div class="europe-map__map-info-row">
                                    <div class="europe-map__map-info-detail">${co2savingTranslation}</div>
                                    <div class="europe-map__map-info-detail">${co2Num} t/a</div>
                                </div>
                            </div>
                        </div>`
            );
            const zoomControl = document.querySelector('.leaflet-control-zoom');
            marker.on('popupopen', (e) => {
                marker.setIcon(activeIcon);
                zoomControl.style.opacity = 0;
            });

            marker.on('popupclose', (e) => {
                marker.setIcon(defaultIcon);
                zoomControl.style.opacity = 1;
            });

            /* statt direkt zum map-Objekt werden die Marker zum Cluster-Layer hinzugefügt.
                          Bestehende Marker können bei neuer Suche folgendermaßen gelöscht werden: markers.clearLayers(); */
            marker.addTo(this.clusterer);

            this.allMarkers.push(marker);
        });
    }

    countAllMatchingFilters () {
        this.allMarkers.forEach(marker => {
            let found = true;

            if (this.filter.country.length > 0) {
                console.log('find filter in country');
                if (this.filter.country.indexOf(marker.filter.country) === -1) {
                    found = false;
                }
            }

            if (this.filter.type.length > 0) {
                console.log('find filter in type');
                if (this.filter.type.indexOf(marker.filter.type) === -1) {
                    found = false;
                }
            }

            if (this.filter.state.length > 0) {
                console.log('find filter in state');
                if (this.filter.state.indexOf(marker.filter.state) === -1) {
                    found = false;
                }
            }

            if (this.filter.business.length > 0) {
                console.log('find filter in business');
                if (this.filter.business.indexOf(marker.filter.business) === -1) {
                    found = false;
                }
            }

            if (found === true) {
                this.matchingMarkers.push(marker);
            }
        });
    }

    startFilter () {
        this.clusterer.clearLayers();

        this.allMarkers.forEach(marker => {
            let found = true;

            if (this.filter.country.length > 0) {
                if (this.filter.country.indexOf(marker.filter.country) === -1) {
                    found = false;
                }
            }

            if (this.filter.type.length > 0) {
                if (this.filter.type.indexOf(marker.filter.type) === -1) {
                    found = false;
                }
            }

            if (this.filter.state.length > 0) {
                if (this.filter.state.indexOf(marker.filter.state) === -1) {
                    found = false;
                }
            }

            if (this.filter.business.length > 0) {
                if (this.filter.business.indexOf(marker.filter.business) === -1) {
                    found = false;
                }
            }

            if (found === false) {
                marker.filter.facilityListItem.classList.remove('facility-list__list-item--shown');
                marker.filter.facilityListItem.classList.add('facility-list__list-item--hide');
            } else {
                marker.filter.facilityListItem.classList.remove('facility-list__list-item--hide');
                marker.filter.facilityListItem.classList.add('facility-list__list-item--shown');

                this.clusterer.addLayer(marker);
                // window.map.fitBounds(this.clusterer.getBounds(), 8);
            }
        });

        window.map.fitBounds(this.clusterer.getBounds(), 8);

        this.$filterCount.textContent = this.activeFilterCount;
        this.$facilityListCount.textContent = this.matchingMarkers.length;

        console.log('this.matchingMarkers.length', this.matchingMarkers.length);

        this.updatedFacts();
        // reset matching marker
        this.matchingMarkers = [];
    }

    resetFilter (zoom) {
        this.clusterer.clearLayers();

        this.$$allFilters.forEach(filter => {
            const matchQuickFilter = this.$em.querySelector('[data-quick-filter="' + filter.dataset.filterValue + '"]');

            if (filter.dataset.filter === 'type') {
                matchQuickFilter.classList.remove('europe-map__quick-filter--active');
                filter.classList.remove('filter-flyout__quick-filter--active');
            } else {
                filter.classList.remove(this.activeFilterClass);
            }
        });

        this.allMarkers.forEach(marker => {
            marker.filter.facilityListItem.classList.remove('facility-list__list-item--hide');
            marker.filter.facilityListItem.classList.add('facility-list__list-item--shown');
        });

        this.activeFilterCount = 0;
        this.$filterCount.textContent = '';
        this.$facilityListCount.textContent = this.allMarkers.length;
        this.matchingMarkers = [];
        this.filter.country = [];
        this.filter.type = [];
        this.filter.state = [];
        this.filter.business = [];

        this.$filterReset.classList.remove('filter-flyout__reset--shown');
        this.$headerFilterReset.classList.remove('europe-map__filter-reset--is-shown');

        // set disable to button
        this.hideSearchCta();

        this.clusterer.addLayers(this.allMarkers);
        window.map.fitBounds(this.clusterer.getBounds(), zoom);
    }

    hideSearchCta () {
        if (this.activeFilterCount > 0 && this.matchingMarkers.length === 0) {
            console.log('button 🚫');
            this.$filterSearch.classList.add('button-small--disable');
            this.$filterSearch.disabled = true;
        } else if (this.activeFilterCount >= 1 && this.matchingMarkers.length >= 1) {
            console.log('button ✅');
            this.$filterSearch.classList.remove('button-small--disable');
            this.$filterSearch.disabled = false;
            this.$filterSearch.classList.remove('button-small--secondary');
            this.$filterSearch.classList.add('button-small--primary');
        } else {
            console.log('button 🧘‍♀️');
            this.$filterSearch.classList.remove('button-small--disable');
            this.$filterSearch.disabled = false;
            this.$filterSearch.classList.remove('button-small--primary');
            this.$filterSearch.classList.add('button-small--secondary');
        }
    }

    noResultsHandler () {
        if (this.$noResults.classList.contains(this.noResultsStateClass)) {
            this.$noResults.classList.remove(this.noResultsStateClass);
        } else {
            this.$noResults.classList.add(this.noResultsStateClass);
        }
    }

    factBarCounter (open) {
        if (open) {
            this.$$allFactBarCount.forEach((fact, index) => {
                if (index >= 1) {
                    const countValue = fact.dataset.factBarValue;
                    const countSuffix = fact.dataset.factBarSuffix;
                    const options = {
                        useEasing: true,
                        useGrouping: true,
                        decimalPlaces: 2,
                        separator: '.',
                        decimal: ',',
                        suffix: `${countSuffix}`
                    };
                    const countUp = new CountUp(fact, 0, countValue, 0, 2, options);
                    countUp.start();
                }
            });
        } else {
            const fact = this.$$allFactBarCount[0];
            const countValue = fact.dataset.factBarValue;
            const countSuffix = fact.dataset.factBarSuffix;
            const options = {
                useEasing: true,
                useGrouping: true,
                decimalPlaces: 2,
                separator: '.',
                decimal: ',',
                suffix: `${countSuffix}`
            };
            const countUp = new CountUp(fact, 0, countValue, 0, 2, options);
            countUp.start();
        }
    }

    calculateAllFacts () {
        if (this.matchingMarkers.length > 0) {
            let co2saving = 0;
            let power = 0;
            let ratedcapa = 0;

            this.matchingMarkers.forEach((marker) => {
                co2saving += marker.filter.co2saving;
                power += marker.filter.plannedPowerProduction;
                ratedcapa += marker.filter.ratedCapacity;
            });
            return { co2saving, power, ratedcapa };
        } else {
            return null;
        }
    }

    resetFacts () {
        console.log('factbarJS', factbarJS);
        this.$factBar.querySelector('[data-fact-bar="co2saving"]').dataset.factBarValue = factbarJS.co2;
        this.$factBar.querySelector('[data-fact-bar="ratedcapa"]').dataset.factBarValue = factbarJS.ratedcapa;
        this.$factBar.querySelector('[data-fact-bar="power"]').dataset.factBarValue = factbarJS.power;

        if (this.$factBar.classList.contains(this.factBarStateClass)) {
            this.factBarCounter();
            this.factBarCounter(open);
        } else {
            this.factBarCounter();
        }
    }

    updatedFacts () {
        const newFacts = this.calculateAllFacts();

        if (newFacts !== null) {
            this.$$allFactBarCount.forEach(fact => {
                const isFact = fact.dataset.factBar;
                const newFact = newFacts[isFact];
                console.log('isFact:', isFact);
                console.log('newFact:', newFact);
                fact.dataset.factBarValue = newFact;
            });
        }

        if (this.$factBar.classList.contains(this.factBarStateClass)) {
            this.factBarCounter();
            this.factBarCounter(open);
        } else {
            this.factBarCounter();
        }
    }
}

export { EuropeMap };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $ems = $context.querySelectorAll('[data-europe-map="root"]');

        for (let i = 0; i < $ems.length; i++) {
            const $em = new EuropeMap($ems[i]);
            $em.init();
        }
    }
});
